import { useState } from 'react';
import { Link } from 'react-router-dom';

const counties = [
  {
    name: 'Box Elder County',
    cities: [
      { name: 'Tremonton', url: '/service-area/box-elder/tremonton' },
      { name: 'Brigham City', url: '/service-area/box-elder/brigham-city' },
      { name: 'Garland', url: '/service-area/box-elder/garland' },
      { name: 'Honeyville', url: '/service-area/box-elder/honeyville' },
      { name: 'Willard', url: '/service-area/box-elder/willard' }
    ],
    color: 'bg-blue-600',
    description: 'Our home base - serving the entire Box Elder County area'
  },
  {
    name: 'Weber County',
    cities: [
      { name: 'Ogden', url: '/service-area/weber/ogden' },
      { name: 'Roy', url: '/service-area/weber/roy' },
      { name: 'North Ogden', url: '/service-area/weber/north-ogden' },
      { name: 'Plain City', url: '/service-area/weber/plain-city' },
      { name: 'Farr West', url: '/service-area/weber/farr-west' }
    ],
    color: 'bg-green-600',
    description: 'Comprehensive remodeling services throughout Weber County'
  },
  {
    name: 'Davis County',
    cities: [
      { name: 'Layton', url: '/service-area/davis/layton' },
      { name: 'Kaysville', url: '/service-area/davis/kaysville' },
      { name: 'Syracuse', url: '/service-area/davis/syracuse' },
      { name: 'Clearfield', url: '/service-area/davis/clearfield' },
      { name: 'Farmington', url: '/service-area/davis/farmington' }
    ],
    color: 'bg-purple-600',
    description: 'Expert kitchen and bath remodeling in Davis County'
  },
  {
    name: 'Cache County',
    cities: [
      { name: 'Logan', url: '/service-area/cache/logan' },
      { name: 'Smithfield', url: '/service-area/cache/smithfield' },
      { name: 'Hyrum', url: '/service-area/cache/hyrum' },
      { name: 'Providence', url: '/service-area/cache/providence' },
      { name: 'North Logan', url: '/service-area/cache/north-logan' }
    ],
    color: 'bg-orange-600',
    description: 'Custom cabinetry and renovations in Cache Valley'
  }
];

export const ServiceAreaHighlight = () => {
  const [selectedCounty, setSelectedCounty] = useState(0);

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl font-bold text-gray-900 md:text-4xl">
            Serving Utah's Wasatch Front
          </h2>
          <p className="text-xl text-gray-600">
            Professional remodeling services across 4 counties and 50+ cities
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {/* Interactive Map/Counties */}
          <div className="space-y-6">
            <div className="grid grid-cols-2 gap-4">
              {counties.map((county, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedCounty(index)}
                  className={`p-6 text-left transition-all duration-300 rounded-lg border-2 ${
                    selectedCounty === index
                      ? `${county.color} text-white border-transparent shadow-lg`
                      : 'bg-white text-gray-700 border-gray-200 hover:border-gray-300 hover:shadow-md'
                  }`}>
                  <h3 className="mb-2 text-lg font-semibold">{county.name}</h3>
                  <p
                    className={`text-sm ${
                      selectedCounty === index
                        ? 'text-white/90'
                        : 'text-gray-600'
                    }`}>
                    {county.description}
                  </p>
                </button>
              ))}
            </div>

            {/* Selected County Details */}
            <div className="p-6 bg-white rounded-lg shadow-md">
              <h3 className="mb-4 text-xl font-semibold text-gray-900">
                {counties[selectedCounty].name}
              </h3>
              <div className="mb-4">
                <h4 className="mb-2 text-sm font-medium tracking-wide text-gray-700 uppercase">
                  Major Cities We Serve:
                </h4>
                <div className="flex flex-wrap gap-2">
                  {counties[selectedCounty].cities.map((city, index) => (
                    <Link
                      key={index}
                      to={city.url}
                      className="px-3 py-1 text-sm text-gray-700 bg-gray-100 rounded-full transition-colors duration-200 hover:bg-gray-200 hover:text-gray-900">
                      {city.name}
                    </Link>
                  ))}
                </div>
              </div>
              <p className="text-gray-600">
                {counties[selectedCounty].description}
              </p>
            </div>
          </div>

          {/* Service Area Map */}
          <div className="relative">
            <div className="overflow-hidden bg-white rounded-lg shadow-lg">
              <iframe
                src="https://www.google.com/maps/d/u/0/embed?mid=1C9TRHcf1DcGlPQg2P__ebINF6VP_XJk&ehbc=2E312F"
                width="100%"
                title="Oak and Stone Remodel Service Area Map"
                loading="lazy"
                style={{ border: 0, height: '335px', minHeight: '335px' }}
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full">
                Your browser does not support iframes. Please visit our Google
                Maps page directly.
              </iframe>
            </div>

            {/* Trust Badges */}
            <div className="grid grid-cols-2 gap-4 mt-6">
              <div className="p-4 text-center bg-white rounded-lg shadow-md">
                <div className="flex justify-center items-center mx-auto mb-2 w-12 h-12 bg-green-100 rounded-full">
                  <svg
                    className="w-6 h-6 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h4 className="text-sm font-semibold text-gray-900">
                  Licensed & Insured
                </h4>
                <p className="text-xs text-gray-600">
                  Full contractor licensing
                </p>
              </div>

              <div className="p-4 text-center bg-white rounded-lg shadow-md">
                <div className="flex justify-center items-center mx-auto mb-2 w-12 h-12 bg-blue-100 rounded-full">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h4 className="text-sm font-semibold text-gray-900">
                  35+ Years Experience
                </h4>
                <p className="text-xs text-gray-600">Trusted local expertise</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <Link
            to="/service-area"
            className="inline-flex items-center px-8 py-3 text-base font-medium text-white rounded-md border border-transparent transition-colors duration-300 bg-primary hover:bg-primary-hover">
            View Complete Service Area
            <svg
              className="ml-2 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 5l7 7-7 7"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};
